<template>
  <div
    class="relative d-flex fill-height fill-width align-center justify-center"
    :class="[color]"
  >
    <div
      class="rotating-background"
      :style="{ transform: `rotate(${rotation}deg)` }"
    >
      <svg height="100%" width="100%" viewBox="0 0 200 200">
        <path
          v-for="(_, index) in Array.from({ length: 12 })"
          :key="index"
          :d="getPath(index)"
          :fill="index % 2 === 0 ? `#00000030` : `#00000060`"
        />
      </svg>
    </div>

    <div class="overflow-y-auto" style="z-index: 999; height: 100vh">
      <slot />
    </div>

    <!-- Só renderiza se confetti for true -->
    <Confetti v-if="confetti" />
  </div>
</template>

<script>
import Confetti from "../confetti/Confetti.vue";

export default {
  name: "RotatoryBackground",

  components: {
    Confetti,
  },

  props: {
    color: {
      type: String,
      default: "success",
    },

    confetti: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rotation: 0,
      animationFrame: null,
    };
  },

  mounted() {
    const dialog = document.querySelector(".v-dialog--fullscreen");
    if (dialog) dialog.style.overflow = "hidden";

    this.startAnimation();
  },

  beforeDestroy() {
    const dialog = document.querySelector(".v-dialog--fullscreen");
    if (dialog) dialog.style.overflow = "";

    this.stopAnimation();
  },

  methods: {
    startAnimation() {
      let startTime = null;

      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        this.rotation = (elapsed / 50) % 360;
        this.animationFrame = requestAnimationFrame(animate);
      };

      this.animationFrame = requestAnimationFrame(animate);
    },

    stopAnimation() {
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
    },

    getPath(index) {
      const angle = (index / 12) * 360;
      const largeRadius = 100;
      const smallRadius = 2;

      const toRadians = (deg) => (deg * Math.PI) / 180;
      const x1 = 100 + largeRadius * Math.cos(toRadians(angle));
      const y1 = 100 + largeRadius * Math.sin(toRadians(angle));
      const x2 = 100 + smallRadius * Math.cos(toRadians(angle));
      const y2 = 100 + smallRadius * Math.sin(toRadians(angle));
      const x3 = 100 + largeRadius * Math.cos(toRadians(angle + 15));
      const y3 = 100 + largeRadius * Math.sin(toRadians(angle + 15));
      const x4 = 100 + smallRadius * Math.cos(toRadians(angle + 15));
      const y4 = 100 + smallRadius * Math.sin(toRadians(angle + 15));

      return `M ${x2} ${y2} L ${x1} ${y1} A ${largeRadius} ${largeRadius} 0 0 1 ${x3} ${y3} L ${x4} ${y4} Z`;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
